var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.255 3.172c-5.729-.13-10.813 3.661-12.313 9.193.068-.026-.073.016 0 0-5.167 3.401-5.229 10.812-.328 14.589l.005-.01-.01.042c1.568 1.182 3.474 1.813 5.438 1.807h6.896l.042.036h6.922c8.917.073 12.5-11.469 5.115-16.464-.635-2.349-1.943-4.458-3.76-6.068l-.057.057.005-.068c-2.203-1.943-5.021-3.047-7.953-3.115zm-.479 5.531c1.656-.057 3.359.49 4.646 1.531 1.609 1.344 2.526 3.344 2.484 5.438v.693c4.708-.094 4.708 7.016 0 6.922h-6.922l-.01.01v-.052h-6.927c-.49 0-.974-.104-1.422-.307-2.203-.995-2.729-3.891-1.021-5.604 1.714-1.708 4.604-1.182 5.604 1.021l4.016-4.016c-1.333-1.74-3.26-2.932-5.411-3.354.026-.01.052-.031.073-.026 1.26-1.385 3.026-2.198 4.896-2.255z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudIcon);
export default __webpack_public_path__ + "static/media/google-cloud-icon.3e0164e11d356b1332a867c149869b34.svg";
export { ForwardRef as ReactComponent };